import { createValidator, required } from 'util/validation'

import { ConfiguracaoAssinaturaDigitalModel } from './model-assinaturaDigital'

export const validate = createValidator<ConfiguracaoAssinaturaDigitalModel>({
  usuario: [required],
  senha: [required],
})
